import { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AppContext } from '../Context/AppContextProvide';

// `featureEnabled` lets a hidden-gated route also open to any admin when a feature toggle is on
// (e.g. File Processing). Hidden users always have access regardless of the toggle.
export default function HiddenAdminAuthRoute({ component: Component, render: renderProp, authed, featureEnabled, ...rest }) {
  const { user, isLoggedOut, loading, authInitialized } = useContext(AppContext);

  const isAuthenticated = user?.user_id && new Date().getTime() < user.will_expire_at;
  const isAdmin = !!user?.is_admin;
  const isHidden = !!user?.is_hidden;
  const hasAccess = isHidden || !!featureEnabled;

  if (isLoggedOut && !isAuthenticated) {
    return <Redirect to={{ pathname: '/signin' }} />;
  }

  if (loading && !authInitialized) {
    return <div>Loading...</div>;
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated && isAdmin && hasAccess) {
          return renderProp ? renderProp(props) : <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{ pathname: '/notfound', state: { from: props.location } }}
            />
          );
        }
      }}
    />
  );
}